// extracted by mini-css-extract-plugin
module.exports = {"bar":"Bar_bar_1T1XJRp"};